export default __webpack_public_path__ + "static/media/announcement_5_lyte@3x.81bf7da0.png";